import React from 'react';
import { Link } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/**
 * Bandeau affiché à un salarié encore sur son mot de passe provisoire.
 *
 * L'email d'activation lui dit « changez votre mot de passe dès votre première connexion », et rien dans
 * l'application ne le lui rappelait ensuite : le drapeau `is_temp_password` était renvoyé par le serveur,
 * typé dans le contexte d'authentification, et utilisé nulle part. Un mot de passe généré par la machine,
 * transmis par email, restait donc en place indéfiniment.
 *
 * Volontairement NON fermable : ce n'est pas une information, c'est une chose à faire. Il disparaît de
 * lui-même dès que le mot de passe est changé (le serveur remet le drapeau à zéro).
 */
export const MotDePasseProvisoireBanner = () => {
    const { user } = useAuth();
    if (user?.type !== 'employe' || !user?.is_temp_password) return null;

    return (
        <div className="mb-4 flex items-start gap-3 rounded-xl border border-state-warn/30 bg-state-warn-soft px-4 py-3 flex-wrap sm:flex-nowrap">
            <span className="w-7 h-7 shrink-0 rounded-lg bg-surface border border-border text-content flex items-center justify-center">
                <KeyRound size={14} />
            </span>
            <div className="flex-1 min-w-0">
                <p className="text-[13px] font-bold text-content">Votre mot de passe est encore celui de l'email.</p>
                <p className="mt-[3px] text-[12.5px] leading-[1.5] text-content-muted text-pretty">
                    Il a été fabriqué par l'application et envoyé par courriel : choisissez-en un à vous.
                </p>
            </div>
            <Link to="/parametres"
                className="inline-flex items-center h-[34px] px-[14px] shrink-0 rounded-full bg-surface border border-border text-[12.5px] font-semibold text-content hover:bg-surface-soft transition-colors">
                Changer mon mot de passe
            </Link>
        </div>
    );
};
